import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StarField"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/components/ui/StarField.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VortexSymbol"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/components/ui/VortexSymbol.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WaitlistTrigger"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/components/WaitlistTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/node_modules/next/dist/client/image-component.js");
